export default __webpack_public_path__ + "static/media/headset10.1750c8a2.jfif";